import React from "react";
import AppStore from "../../assets/application/applogo.png";
import PlayStore from "../../assets/application/googleplay.png";
import "./Application.css";
import { useTranslation } from "react-i18next";
const Application = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container mt50">
        <h4 className="text-center mb-5">{t("MobileApplications")}</h4>
        <div className="row text-center justify-content-center">
          <div className="col-lg-4 col-md-5 col-sm-6 mb-5">
            <a
              href="https://apps.apple.com/us/app/m%C3%BCkemel/id6753164005"
              target="__blank"
              className="border p-4 rounded-3"
            >
              <img src={AppStore} alt="App Store" width={200} />
            </a>
          </div>
          <div className="col-lg-4 col-md-5 col-sm-6 mb-5">
            <a
              href="/"
              class="border p-4 bg-light disabled-link rounded-3"
              aria-disabled="true"
              tabindex="-1"
            >
              <img src={PlayStore} alt="App Store" width="200" />
            </a>
            <p className="mt-3 text-danger">{t("GooglePlayAlert")}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Application;
